import { useAclContext } from '../../Acl/Components/AclContextProvider';

/** Shows the MZČR settings (workplace certificate). */
export const MZCR_SETUP_ACL = 'mzcr_setup';
/** The MZČR services themselves - user-api grants it once the workplace has a certificate. */
export const MZCR_SERVICES_ACL = 'patient_health_mzcr';

/**
 * Access to the MZČR services, the same two-step way as NCZI: `mzcr_setup` lets the user set
 * MZČR up, `patient_health_mzcr` comes once it is set up. With the setup only, the services
 * still show - in place of their content the user gets the certificate upload.
 */
export default function useMzcrAccess() {
	const { isAllowed } = useAclContext();
	const canSetup = isAllowed(MZCR_SETUP_ACL);
	const hasServices = isAllowed(MZCR_SERVICES_ACL);

	return { canSetup, hasServices, isVisible: canSetup || hasServices };
}
